export default __webpack_public_path__ + "static/media/app-bar-login.fe55c9c3.svg";